import script from "./Boxs.vue?vue&type=script&setup=true&lang=js"
export * from "./Boxs.vue?vue&type=script&setup=true&lang=js"

import "./Boxs.vue?vue&type=style&index=0&id=66b687ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b687ca"]])

export default __exports__